const downloadIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.5 3a.5.5 0 0 0-.5.5v8.086l-3.5-3.5c-.178-.178-.5-.051-.5.207v1.914a.5.5 0 0 0 .146.354l4.147 4.146a1 1 0 0 0 1.414 0l4.147-4.146a.5.5 0 0 0 .146-.354V8.293c0-.258-.322-.385-.5-.207l-3.5 3.5V3.5a.5.5 0 0 0-.5-.5h-1z"/><path d="M3.5 14a.5.5 0 0 0-.5.5V17a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V17a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2.5a.5.5 0 0 0-.5-.5h-1z"/></svg>
`;

export { downloadIcon };
//# sourceMappingURL=index.esm.js.map
